import { render, staticRenderFns } from "./actions-column.vue?vue&type=template&id=f05d3f1c&scoped=true&"
import script from "./actions-column.vue?vue&type=script&lang=js&"
export * from "./actions-column.vue?vue&type=script&lang=js&"
import style0 from "./actions-column.vue?vue&type=style&index=0&id=f05d3f1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05d3f1c",
  null
  
)

export default component.exports